var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCalendar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.277,
    height: 10.623,
    viewBox: "0 0 12.277 10.623",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(0 -8.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M11.534,10.052h-.54V9.176a.552.552,0,0,0-.552-.552h-.387a.552.552,0,0,0-.552.552v.876H8.254V9.176A.552.552,0,0,0,7.7,8.624H7.315a.552.552,0,0,0-.552.552v.876H5.513V9.176a.552.552,0,0,0-.552-.552H4.575a.552.552,0,0,0-.552.552v.876H2.773V9.176a.552.552,0,0,0-.552-.552H1.834a.552.552,0,0,0-.552.552v.876H.743A.744.744,0,0,0,0,10.795v7.8a.648.648,0,0,0,.647.647H11.63a.648.648,0,0,0,.647-.647v-7.8a.744.744,0,0,0-.743-.743ZM9.84,9.176a.216.216,0,0,1,.216-.216h.387a.216.216,0,0,1,.216.216v.876H9.84Zm-2.741,0a.216.216,0,0,1,.216-.216H7.7a.216.216,0,0,1,.216.216v.876H7.1Zm-2.741,0a.216.216,0,0,1,.216-.216h.387a.216.216,0,0,1,.216.216v.876H4.359Zm-2.741,0a.216.216,0,0,1,.216-.216h.387a.216.216,0,0,1,.216.216v.876H1.619ZM.336,10.795a.408.408,0,0,1,.408-.408H11.534a.408.408,0,0,1,.408.408v1.091H.336Zm11.606,7.8a.312.312,0,0,1-.312.312H.647A.312.312,0,0,1,.336,18.6V12.222H11.942Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M10.36,54.115h1.03a.36.36,0,0,0,.36-.36v-.76a.36.36,0,0,0-.36-.36H10.36a.36.36,0,0,0-.36.36v.76A.36.36,0,0,0,10.36,54.115Zm-.024-1.12a.024.024,0,0,1,.024-.024h1.03a.024.024,0,0,1,.024.024v.76a.024.024,0,0,1-.024.024H10.36a.024.024,0,0,1-.024-.024Z",
    transform: "translate(-9.041 -39.79)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M40.281,54.115h1.03a.36.36,0,0,0,.36-.36v-.76a.36.36,0,0,0-.36-.36h-1.03a.36.36,0,0,0-.36.36v.76A.36.36,0,0,0,40.281,54.115Zm-.024-1.12a.024.024,0,0,1,.024-.024h1.03a.024.024,0,0,1,.024.024v.76a.024.024,0,0,1-.024.024h-1.03a.024.024,0,0,1-.024-.024Z",
    transform: "translate(-36.092 -39.79)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M70.2,54.115h1.03a.36.36,0,0,0,.36-.36v-.76a.36.36,0,0,0-.36-.36H70.2a.36.36,0,0,0-.36.36v.76a.36.36,0,0,0,.36.36Zm-.024-1.12a.024.024,0,0,1,.024-.024h1.03a.024.024,0,0,1,.024.024v.76a.024.024,0,0,1-.024.024H70.2a.024.024,0,0,1-.024-.024Z",
    transform: "translate(-63.144 -39.79)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M100.124,54.115h1.03a.36.36,0,0,0,.36-.36v-.76a.36.36,0,0,0-.36-.36h-1.03a.36.36,0,0,0-.36.36v.76a.36.36,0,0,0,.36.36Zm-.024-1.12a.024.024,0,0,1,.024-.024h1.03a.024.024,0,0,1,.024.024v.76a.024.024,0,0,1-.024.024h-1.03a.024.024,0,0,1-.024-.024Z",
    transform: "translate(-90.195 -39.79)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M10.36,74.771h1.03a.36.36,0,0,0,.36-.36v-.76a.36.36,0,0,0-.36-.36H10.36a.36.36,0,0,0-.36.36v.76a.36.36,0,0,0,.36.36Zm-.024-1.12a.024.024,0,0,1,.024-.024h1.03a.024.024,0,0,1,.024.024v.76a.024.024,0,0,1-.024.024H10.36a.024.024,0,0,1-.024-.024Z",
    transform: "translate(-9.041 -58.464)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M40.281,74.771h1.03a.36.36,0,0,0,.36-.36v-.76a.36.36,0,0,0-.36-.36h-1.03a.36.36,0,0,0-.36.36v.76A.36.36,0,0,0,40.281,74.771Zm-.024-1.12a.024.024,0,0,1,.024-.024h1.03a.024.024,0,0,1,.024.024v.76a.024.024,0,0,1-.024.024h-1.03a.024.024,0,0,1-.024-.024Z",
    transform: "translate(-36.092 -58.464)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M70.2,74.771h1.03a.36.36,0,0,0,.36-.36v-.76a.36.36,0,0,0-.36-.36H70.2a.36.36,0,0,0-.36.36v.76a.36.36,0,0,0,.36.36Zm-.024-1.12a.024.024,0,0,1,.024-.024h1.03a.024.024,0,0,1,.024.024v.76a.024.024,0,0,1-.024.024H70.2a.024.024,0,0,1-.024-.024Z",
    transform: "translate(-63.144 -58.464)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M100.124,74.771h1.03a.36.36,0,0,0,.36-.36v-.76a.36.36,0,0,0-.36-.36h-1.03a.36.36,0,0,0-.36.36v.76A.36.36,0,0,0,100.124,74.771Zm-.024-1.12a.024.024,0,0,1,.024-.024h1.03a.024.024,0,0,1,.024.024v.76a.024.024,0,0,1-.024.024h-1.03a.024.024,0,0,1-.024-.024Z",
    transform: "translate(-90.195 -58.464)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M10.36,95.43h1.03a.36.36,0,0,0,.36-.36v-.76a.36.36,0,0,0-.36-.36H10.36a.36.36,0,0,0-.36.36v.76A.36.36,0,0,0,10.36,95.43Zm-.024-1.12a.024.024,0,0,1,.024-.024h1.03a.024.024,0,0,1,.024.024v.76a.024.024,0,0,1-.024.024H10.36a.024.024,0,0,1-.024-.024Z",
    transform: "translate(-9.041 -77.142)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M40.281,95.43h1.03a.36.36,0,0,0,.36-.36v-.76a.36.36,0,0,0-.36-.36h-1.03a.36.36,0,0,0-.36.36v.76A.36.36,0,0,0,40.281,95.43Zm-.024-1.12a.024.024,0,0,1,.024-.024h1.03a.024.024,0,0,1,.024.024v.76a.024.024,0,0,1-.024.024h-1.03a.024.024,0,0,1-.024-.024Z",
    transform: "translate(-36.092 -77.142)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M71.471,94.58a.168.168,0,0,0-.235.031l-.7.915-.393-.5a.168.168,0,1,0-.263.208l.528.666a.168.168,0,0,0,.132.064h0a.168.168,0,0,0,.132-.066l.831-1.087A.168.168,0,0,0,71.471,94.58Z",
    transform: "translate(-63.144 -77.68)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M101.4,94.58a.168.168,0,0,0-.235.031l-.7.915-.393-.5a.168.168,0,0,0-.263.208l.528.666a.168.168,0,0,0,.132.064h0a.168.168,0,0,0,.132-.066l.831-1.087a.168.168,0,0,0-.032-.235Z",
    transform: "translate(-90.2 -77.68)",
    fill: "#333"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendar.49725533.svg";
export { ForwardRef as ReactComponent };